import { ReactComponent as UserIcon } from '@/assets/icons/ri-user-heart-fill.svg'
import { ReactComponent as RiWhatsappLine } from '@/assets/icons/ri-whatsapp-line.svg';


const CoverLogoSection = ({ coverUrl, logoUrl }) => (
	<>
		<div className="text-jsm">Cover & Logo</div>
		
		<div className="flex gap-2 mt-2">
			<div className="relative h-[180px] w-[360px]">
				<img
					src={coverUrl !== "" ? coverUrl : "https://placehold.co/360x180"}
					alt=""
					className="absolute top-0 left-0 h-[180px] w-[360px] object-cover"
					width={360}
					height={180}
				/>
				<img
					src={logoUrl}
					alt=""
					className="absolute bottom-4 left-4 h-[60px] w-[60px] object-cover border border-grey-line-subtle hover:border-red-secondary"
					width={60}
					height={60}
				/>
			</div>
		</div>
	</>
);

const AdminSection = ({adminName, adminPhone}) => (
	<>
		<div className="text-jsm">Admin</div>
		
		<div className="flex flex-col gap-2 mt-2">
			<div className='flex w-full items-center p-2 gap-8'>
				<div className='text-red-primary'>
					<UserIcon />
				</div>
				<div className='flex flex-col p-0 gap-1'>
					<p
					className='text-sm text-grey-dark'>{adminName}</p>
					<p className='font-medium text-sm'>{adminPhone}</p>
				</div>
			</div>
			<div
				aria-hidden
				onClick={()=> window.open(`https://wa.me/${adminPhone}`, "_blank")}
				className="cursor-pointer text-black-primary
				gap-2 flex justify-center items-center px-4 py-2
				rounded border border-grey-line-subtle bg-white">
				<RiWhatsappLine/>
				<div>Chat Admin</div>
			</div>
		</div>
	</>
);

const PhotosSection = ({photoUrls}) => (
	<>
		<div className="text-jsm">Gallery Activities</div>
		
		<div className="flex flex-col gap-3 mt-2">
			{photoUrls.map(url => (
					<img
					src={url}
					alt=""
					className="h-[180px] w-[360px] object-cover"
				/>
			))}
		</div>
	</>
);

const RightSection = ({logoUrl, coverUrl, photoUrls, adminName, adminPhone}: ClubRightSectionProps) => (
		<>
			<div className="p-6">
				<CoverLogoSection logoUrl={logoUrl} coverUrl={coverUrl} />
			</div>
			<div className="p-6 border-t border-grey-line-subtle">
				<AdminSection adminName={adminName} adminPhone={adminPhone} />
			</div>
			<div className="p-6 border-t border-grey-line-subtle">
				<PhotosSection photoUrls={photoUrls} />
			</div>
		</>
	);

export default RightSection;
